import Vue from 'vue'
import VueI18n from 'vue-i18n'
import globalComponents from './components'
import App from './App.vue'
import router from './router/index' // 中间带
import apis from './api/apis_moudles'
import utils from './utils'
import vcolorpicker from 'vcolorpicker'
import directives from './directives'
// import VConsole from 'vconsole';

// new VConsole();

// eccs项目用到
import store from './store/index.js'
import { Locale } from 'cube-ui'
import enUSMessages from 'cube-ui/src/locale/lang/en-US'
import BaiduMap from 'vue-baidu-map'

import LangENUS from './lang/en-us'
import LangZHCN from './lang/zh-cn'

// wxsdk
import wxsdk from 'ny-wxsdk'
import common from '@/mixins/common.js'
Vue.mixin(common)

globalComponents()
Vue.prototype.$apis = apis // 统一api
Vue.prototype.$utils = utils // 统一工具
Vue.prototype.$wx = wxsdk // 统一工具
directives() // 注入全局指令
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'FpnBvDSclDsIiAjH3ugg7VULGqAh6zmb'
})
Vue.use(vcolorpicker)

Vue.config.productionTip = false
console.log(utils, 40)

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: utils.getLang() || 'zh-cn',
  messages: {
    'en-us': LangENUS,
    'zh-cn': LangZHCN
  }
})
// cube-ui组件语言更改
Vue.use(Locale)

// 切换至英语，并且缓存当前语言包
if (i18n.locale != 'zh-cn') {
  Locale.use('en-US', enUSMessages)
} else {
  Locale.use('zh-CN')
}

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount('#app')
